import useSWR from 'swr';
import { customSWRConfig, customSWRResponse } from '../../../model/types';
import { isValidNumberForRequest } from '../../../utils/validation';
import useSWRCacheKeys from '../../useSWRCacheKeys';
import { Filter } from '../filters/useFilters';
import { TriggerAction } from '../triggers/useTriggers';

interface Automation {
    action: TriggerAction[];
    createdAt: number;
    deleted: boolean;
    enabled: boolean;
    filter: { allConditions: Filter['allConditions']; anyConditions: Filter['anyConditions'] };
    id: number;
    name: string;
    ownerId: number;
    trigger: { cronString: string; fireTime: number };
    userId: number;
}

export default function useCurrentAutomation(
    automationId?: number,
    config: customSWRConfig = {}
): customSWRResponse<Automation> {
    const keys = useSWRCacheKeys(
        isValidNumberForRequest(automationId) ? `/automations/definitions/${automationId}` : null
    );

    return useSWR<Automation>(keys, { ...config });
}

export { type Automation };
